import { useQuery, UseQueryOptions } from "react-query";
import { getAbout } from "../services/about.service";
import { IRequest } from "../interfaces/authentication.interface";
import { useQueryClient } from 'react-query';
import { IAbout } from "../interfaces/about.interface";

export function useGetAbout<T extends any = IRequest<IAbout>>(
    locale: string,
    options?: UseQueryOptions<any, unknown, T>
) {

    const cache = useQueryClient().getQueryData(["about", locale]);

    return useQuery({
        queryKey: ["about", locale],
        queryFn: () => cache ? cache : getAbout(locale),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}
